// Library
import { defineStyleConfig } from '@chakra-ui/react';

export const Link = defineStyleConfig({
  baseStyle: {
    borderRadius: 'base',
    textDecoration: 'underline',
    fontFamily: '"Jost", sans-serif',
    fontSize: 'xs',
    color: 'link.base',
    _hover: {
      bg: 'link.hover',
    },
    _active: {
      bg: 'link.hover',
      color: 'link.active',
    },
    _visited: {
      color: 'link.active',
    },
  },
  variants: {
    sidebar: {
      textDecoration: 'none',
      textAlign: 'center',
      _hover: {
        textDecoration: 'none',
        bg: 'sidebarLink.hover',
      },
      _active: {
        bg: 'sidebarLink.active',
      },
      _focusVisible: {
        bg: 'sidebarLink.hover',
        shadow: 'outline',
      },
    },
    home: {
      textDecoration: 'none',
      textAlign: 'center',
      _hover: {
        textDecoration: 'none',
        bg: 'navScheme.600',
      },
      _active: {
        bg: 'navScheme.700',
      },
      _focusVisible: {
        shadow: 'outline',
      },
    },
    forms: {
      fontSize: 'm',
      textDecoration: 'none',
      textAlign: 'center',
      _hover: {
        textDecoration: 'none',
        bg: 'inputScheme.600',
      },
      _active: {
        bg: 'inputScheme.700',
      },
      _focusVisible: {
        shadow: 'outline',
      },
    },
  },
});
